import * as React from 'react';
import * as Tgcc from '../tgccGlobal';
import Radium, { StyleRoot } from 'radium';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { ButtonToolbar, DropdownButton,Dropdown } from 'react-bootstrap';

const containerStyle: React.CSSProperties = {
    height: '100px',
    width: '100%',
    textAlign: 'center'
};
const navItemStyle: React.CSSProperties = {
    fontFamily: 'AveriaSerifLight',
    color: '#A6A6A6',
    marginRight: '40px',
    cursor: 'pointer',
    ':hover': {
        color: 'black'
    }
};

const dropdownItemStyle: React.CSSProperties = {
    display: 'block',
    padding: '10px 15px',
    fontFamily: 'AveriaSerifLight',
    fontSize: '16px',
    borderBottom: '1px solid #eee',
    textTransform: 'uppercase'
  };

  const hamburgerStyle: React.CSSProperties = {
    backgroundImage: 'url(' + Tgcc.ResolveUrl("~/images/hamburger_2.png") + ')',
    height: '50px',
    width: '50px',
    backgroundPosition: 'center',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    border: 'none',
    backgroundColor: 'transparent',
    padding: 0
  };

const navBar: React.CSSProperties = {
    display: 'flex',
    alignSelf: 'center',
    flexDirection: 'row',
    flexWrap: 'wrap',
    justifyContent: 'center'
};
const topNav: React.CSSProperties = {
    width: '100%',
    backgroundColor: 'white',
    height: '75px',
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-around',
    position: 'fixed',
    zIndex: 2
};
const topNavStyle: React.CSSProperties = {
    width: '131px',
    height: '40px',
    backgroundColor: '#F7F5F0',
    margin: '13px 10px',
    lineHeight: '38px',
    padding: '5px',
    fontFamily: 'AveriaSerifLight',
    cursor: 'pointer',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center'
};
const loggedIn: React.CSSProperties = {
    position: 'absolute',
    right: '80px',
    top: '80px',
    fontFamily: 'AveriaSerifLightItalic'
};
const imgFile = Tgcc.ResolveUrl('~/images/2022Logo.png');

const imgStyles: React.CSSProperties = {
    cursor: 'pointer',
    width: '55px',
    height: '55px'
};
const txt: React.CSSProperties = {
    fontFamily: "AveriaSerifBoldItalic",
    marginLeft: '20px'
};
const logoTxt: React.CSSProperties = {
    marginLeft: '20px',
    display: 'flex',
    alignItems: 'center'
};
const rightNav: React.CSSProperties = {
    display: 'flex'
};
const GCText: React.CSSProperties = {
    fontFamily: "Reitam"
};
const mobileNav: React.CSSProperties = {
    display: 'flex'
};
const hamburger: React.CSSProperties = {
    backgroundImage: 'url(' + Tgcc.ResolveUrl("~/images/hamburger_2.png") + ')',
    height: '50px',
    width: '50px',
    backgroundPosition: 'center',
    backgroundSize: 'cover'
};
const topLoginStyle = Object.assign({}, topNavStyle, { margin: '13px 10px 20px' });

class _IndigoHeader extends React.Component<Tgcc.BaseProps, any> {
    openDashboard = () => { browserHistory.push(Tgcc.Routes.IndigoDashboard); };
    openCSR = () => { browserHistory.push(Tgcc.Routes.CSR); };
    openDesign = () => { browserHistory.push(Tgcc.Routes.IndigoDesignListView); };
    openHome = () => { browserHistory.push(Tgcc.Routes.Indigo); };
    openContact = () => { browserHistory.push(Tgcc.Routes.Contact); };
    openProducts = () => { browserHistory.push(Tgcc.Routes.IndigoProductListView); };
    openRegister = () => { browserHistory.push(Tgcc.Routes.IndigoRegister); };
    loginUser = () => { browserHistory.push(Tgcc.Routes.IndigoLogin); };

    logoutUser = () => {
        Tgcc.LogoutIndigoUser(this.props.dispatch, this.props.state.LoginData);
        this.props.dispatch({ type: Tgcc.StateAction.ForwardLocation, payload: this.props.state.ActiveProof });
    };

    getLoginLink() {
        if (this.props.state.LoginData) {
            return <div style={topLoginStyle} className="logStyle" key={1} onClick={this.logoutUser}>Logout</div>;
        }
        return <div style={topLoginStyle} className="logStyle" key={2} onClick={this.loginUser}>Login</div>;
    }

    getDashboardLink() {
        if (!this.props.state.LoginData) {
            return <div style={topNavStyle} key={3} className="acctStyle" onClick={this.openRegister}>Create Account</div>;
        }
        return <div style={topNavStyle} key={4} className="acctStyle" onClick={this.openDashboard}>Dashboard</div>;
    }

    getUserName() {
        if (this.props.state.LoginData && this.props.state.LoginData.impersonate) {
            return <div style={loggedIn}>Impersonating: {this.props.state.LoginData.impersonate}</div>;
        }
        if (this.props.state.UserInfo && this.props.state.UserInfo.firstName) {
            return <div style={loggedIn}>Logged in as: {this.props.state.UserInfo.firstName}</div>;
        }
    }

    openProofEdit = () => {
        if (this.props.state.LoginData && this.props.state.UserInfo) {
            browserHistory.push(Tgcc.Routes.IndigoProofEdit);
        } else {
            browserHistory.push(Tgcc.Routes.IndigoRegister);
        }
    };

    getMobile() {
        const logLink = this.getLoginLink();
        const dbLink = this.getDashboardLink();
    
        if (window.innerWidth <= 440) {
            return (
                <div style={mobileNav}>
                    <Dropdown>
                        <Dropdown.Toggle
                            id="mobile-dropdown"
                            style={hamburgerStyle}
                            variant="light"
                        >
                            {/* No text — the hamburger image is the visual trigger */}
                        </Dropdown.Toggle>
    
                        <Dropdown.Menu>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="101" onClick={this.openHome}>HOME</Dropdown.Item>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="102" onClick={this.openProofEdit}>GET STARTED</Dropdown.Item>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="103" onClick={this.openDesign}>DESIGNS</Dropdown.Item>
                            <Dropdown.Item style={dropdownItemStyle} eventKey="104" onClick={this.openProducts}>PRODUCTS</Dropdown.Item>
                        </Dropdown.Menu>
                    </Dropdown>
                    <div style={mobileNav} className='campusMobileLink'>
                        {logLink}
                        {dbLink}
                    </div>
                    {this.getUserName()}
                </div>
            );
        } else {
            return (
                <div style={topNav} className="campusTopNav">
                    <div onClick={this.openHome} style={logoTxt} className="campusNvLogo">
                        <img src={imgFile} style={imgStyles} />
                        <div>
                            <div style={txt}>Custom Resort, Giftshop,</div>
                            <div style={txt}>and Destination Apparel</div>
                        </div>
                    </div>
                    <div style={navBar} className="newCampusNv">
                        <div key={99} style={navItemStyle} onClick={this.openHome}>HOME</div>
                        <div key={97} style={navItemStyle} onClick={this.openProofEdit}>GET STARTED</div>
                        <div key={96} style={navItemStyle} onClick={this.openDesign}>DESIGNS</div>
                        <div key={95} style={navItemStyle} onClick={this.openProducts}>PRODUCTS</div>
                    </div>
                    <div style={rightNav} className="logNav">
                        {logLink}
                        {dbLink}
                    </div>
                    {this.getUserName()}
                </div>
            );
        }
    }

    render() {
        const navBar = this.getMobile();
        return (
            <div style={containerStyle} className="majorHdrDiv">
                {navBar}
            </div>
        );
    }
}

const mapStateToProps = (state: Tgcc.GlobalState) => {
    return {
        state
    };
};

export var IndigoHeader = connect(mapStateToProps)(Radium(_IndigoHeader));
